<template>
    <div class="mb-5">
        <div class="p-3 my-3 bg-light">
            <strong>VAT情報</strong>
        </div>

        <span>対象</span>
        <div class="float-right">
            <a
                href="javascript:void(0)"
                @click="
                value.shipping_tax_target = 'ebay';
                value.shipping_tax_vat = 'IM2760000742';
                value.shipping_tax_name = 'ebay___SDT___IOSS番号 Import One-Stop-Shop___DE';
                "
                >
                eBay-IOSS
            </a>
            &nbsp;
            <a
                href="javascript:void(0)"
                @click="
                value.shipping_tax_target = 'ebay';
                value.shipping_tax_vat = 'GB365608576';
                value.shipping_tax_name = 'ebay___SDT___UKVAT番号 GBVAT (foreign) Registration___GB';
                "
                >
                eBay-GB
            </a>
        </div>
        <SelectTaxTarget
            v-model="value.shipping_tax_target"
            class="mb-3"
            @input="
                value.shipping_tax_name = '';
            "
            />

        <template v-if="value.shipping_tax_target">
            <span>登録番号の名称</span>
            <SelectRegistrationNumber
                v-model="value.shipping_tax_name"
                :target="value.shipping_tax_target"
                class="mb-3"
                />

            <span>登録番号</span>
            <b-form-input
                v-model="value.shipping_tax_vat"
                class="mb-3"
                />
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InputError from '@/components/InputError.vue'
import SelectCountry from '@/components/SelectCountry.vue'
import SelectTaxTarget from '@/components/SelectTaxTarget.vue'
import SelectRegistrationNumber from '@/components/SelectRegistrationNumber.vue'

export default {
    components: {
        SelectCountry,
        SelectTaxTarget,
        SelectRegistrationNumber,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
        from_country: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
        to_country: {
            type: String,
            required: false,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            timer: null,
            key: 0,

//            data_shipping: {},

        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_level',
            'trans',
        ]),
        total() {
            return this.getTotal(this.value)
        },
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        onSetIsEditMode (value) {
            if (value.is_edit_mode) {
                if (value.images.length) {
                    setTimeout(() => {
                        this.fixImage(value.images[0])
                    }, 1000)
                }
            }
        },
        onInputAddressId (value, prefix) {
            if (!value) {
                let keys = Object.keys(this.value)
                for (let i = 0; i < keys.length; i++) {
                    if (keys[i].indexOf(prefix) !== 0) {
                        continue
                    }
                    this.$set(this.value, keys[i], null)
                }
                return
            }
            let keys = Object.keys(value)
            for (let i = 0; i < keys.length; i++) {
                this.$set(this.value, prefix + keys[i], value[keys[i]])
            }
        },
        onInputItemId (value, row) {
            let item = {
                quantity: null,
                hs_code: null,
                country: null,
                product: null,
                price: null,
            }
            if (value) {
                item = {
                    quantity: value.quantity,
                    hs_code: value.hs_code,
                    country: value.country,
                    product: value.product,
                    price: value.price,
                }
            }
            this.$utils.set(row, item)
        },
        getDimensionaWeight(item) {
            let dimensional_weight = parseFloat(item.depth) * parseFloat(item.width) * parseFloat(item.height) / 5000.0
            return Math.ceil(2 * dimensional_weight) / 2 || null
        },
        getSubtotal(item) {
            let subtotal = parseInt(item.quantity || 1) * parseInt(item.price)
            return subtotal || null
        },
        getTotal(value) {
            let data = {
                total_item_price: 0,
                total_item_count: 0,
            }
            for (let i = 0; i < value.length; i++) {
                let subtotal = this.getSubtotal(value[i])
                //if (!model.items[i].country || !model.items[i].product || !model.items[i].price) {
                //    continue
                //}
                data.total_item_price += (Number.parseInt(subtotal) || 0)
                data.total_item_count += (Number.parseInt(value[i].quantity) || 1)
            }
            return data
        },
        onInputHasImporter (is_checked) {
            let elements = Array.from(document.querySelectorAll('.address-content [data*="importer_"]'))
            elements.forEach((element) => {
                element.readOnly = is_checked

                if (is_checked) {
                    this.$set(this.value, element.getAttribute('data'), null)
                }
            })
            if (is_checked) {
                this.address_importer_id = null
            }
        },

        fetchOrders (provider_type) {
            this.$utils.empty(this.data_orders_selected)
            this.$store
                .dispatch('shipping/fetch_orders', {
                    provider_type: provider_type,
                    order_type: this.order_type,
                    order_query: this.order_query,
                })
                .then((response) => {
                    this.data_orders = response.data
                })
                .catch((error) => {
                })
        },
        inputAddressToFromOrder () {
            this.$utils.set(this.value, {
                to_representative: this.data_orders_selected.address.Name,
                to_company: '',
                to_tel: this.data_orders_selected.address.Phone,
                to_email: '',
                to_tax_id: '',
                to_vat_id: '',
                to_eori: '',
                to_line1: this.data_orders_selected.address.Street1,
                to_line2: this.data_orders_selected.address.Street2,
                to_zip: this.data_orders_selected.address.PostalCode,
                to_city: this.data_orders_selected.address.CityName,
                to_state: this.data_orders_selected.address.StateOrProvince,
                to_country: this.data_orders_selected.address.CountryName,

                _no_importer: true,
            })
        },
        onRowClickedOrders (order) {
            this.$utils.set(this.data_orders_selected, order)
            this.$utils.empty(this.data_orders)
        },
        rateShippingCost () {
            this.$utils.empty(this.data_shipping)

            this.$store
                .dispatch('shipping/rate', this.value)
                .then((response) => {
                    this.data_shipping = response.data
                })
                .catch((error) => {
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

